<div class="container-fluid">
  <div class="main">
    <div class="bg-white">
      <div class="row my-3">
        <div class="col">
          <h3 _ngcontent-amo-c355="" class="page-title m-0">
            Push Notifications
          </h3>
        </div>
        <div class="col-auto">
          <div class="row">
            <div class="col-8 w30">
              <input placeholder="Press Enter to search" class="form-control" [(ngModel)]="title" (keyup.enter)="getNotifications(1)" />
            </div>
            <div class="col-auto">
              <button (click)="title='';getNotifications(1);" type="button" class="btn btn-outline-primary">Clear</button>
            </div>
          </div>
          
        </div>
        <div class="col-auto">
          <a
            data-toggle="modal"
            class="btn btn-primary"
            href="#new-notification"
            ><i class="uil uil-plus"></i> Create New Notification</a
          >
        </div>
      </div>
    </div>

    <table class="table table-striped">
      <thead>
        <tr>
          <th>Title</th>
          <th>Body</th>
          <th>Recipients</th>
          <th>Sent</th>
          <th>Clicks</th>
          <th>Time</th>
          <th></th>
        </tr>
      </thead>

      <tbody *ngIf="!loadingData">
        
        <!-- | paginate: { itemsPerPage: perPage, currentPage: page} -->
        <tr  *ngFor="let row of notificationsData  | paginate: { id: 'notPAginate',itemsPerPage: perPage, currentPage: page, totalItems:totalItems }">
          <td>
            <span class="row-title">{{ row.title }}</span>
          </td>
          <td>
            <span class="fig">{{ row.body?.substring(0, 20) + "..." }}</span>
          </td>
          <td>
            <span class="fig">{{ row.users }}</span>
          </td>

          <td>
            <span *ngIf="row.sent">
              <span class="dot mr-2 text-success"></span>Sent</span
            >
            <span *ngIf="!row.sent">
              <span class="dot mr-2 text-danger"></span>Not Sent</span
            >
          </td>
          <td>{{ row.clicks }}</td>
          <td>{{ row.time }}</td>
          <td class="text-right">
            <button
              class="btn btn-outline-dark btn-sm"
              (click)="viewNotification(row)"
            >
              View
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="6" *ngIf="loadingData">
            <div class="text-center" >
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
   
    <pagination-controls 
    id="notPAginate"
    previousLabel="Prev"
    nextLabel="Next"
    responsive="true"
    (pageChange)="getNotifications($event)"></pagination-controls>
    <div class="container-fluid">
      <div class="text-center" *ngIf="loading">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    role="dialog"
    data-backdrop="static-"
    id="new-notification"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <form
          [formGroup]="notificationForm.controls.notification"
          (submit)="sendNotification($event)"
        >
          <div class="modal-header">
            <h4 class="modal-title">Untitled Notification</h4>
            <div>
              <!-- <button class="btn btn-outline-dark shadow mr-2">
              <i class="uil uil-eye"></i> Preview
            </button> -->
              <button
                *ngIf="!loading && !notification['sent']"
                type="submit"
                class="btn btn-success shadow"

              >
                Send Notification <i class="uil uil-message"></i>
              </button>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>

          <div class="modal-body">
            <div class="d-flex btn-holder">
              <div
                class="select-btn align-items-center"
                (click)="openRecepientsModal()"
              >
                <div class="px-4">
                  <div class="label fw-bold">Recipients</div>
                  <div *ngIf="notCriteria" class="value text-primary">
                    {{ total.toLocaleString() }}
                  </div>
                  <div *ngIf="!notCriteria" class="value text-primary">
                    Not confirmed
                  </div>
                </div>
                <!-- <span class="uil uil-chevron-down"></span> -->
              </div>

              <div
                class="select-btn align-items-center"
                (click)="openCTAModal()"
              >
                <div class="px-4">
                  <div class="label fw-bold">On click</div>
                  <div class="value text-primary">
                    {{ notificationForm.get("clickAction").get("page").value }}
                  </div>
                </div>
                <!-- <span class="fe fe-angle-down"></span> -->
              </div>

              <!-- select image -->
              <div class="select-btn align-items-center">
                <div class="img"></div>
                <i class="remove"></i>
                <div>
                  <div class="label fw-bold">Photo</div>

                  <label for="file-"
                    ><input
                      [disabled]="notification['sent']"
                      type="file"
                      id="file-"
                      accept="image/*"
                      [required]="false"
                      class="d-none"
                      (change)="onFileChange($event)"
                    />
                    Select image</label
                  >

                  <div
                    class="value text-primary"
                    *ngIf="
                      notificationForm.get('notification').get('image').value
                    "
                  >
                    {{ fileName }}
                  </div>
                  <span class="uil uil-chevron-down"></span>
                </div>
              </div>
              <div class="align-items-centre">
                <img
                  [src]="selectedImageUrl"
                  class="img-thumbnail"
                  style="max-height: 100px"
                />
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="editor">
                  <div class="e-title">
                    <input
                      [disabled]="notification['sent']"
                      formControlName="title"
                      placeholder="Add title"
                      maxlength="30"
                    />
                    <span class="word-count">0/30 characters</span>
                  </div>

                  <div class="e-desc">
                    <textarea
                      [disabled]="notification['sent']"
                      formControlName="body"
                      placeholder="Notification Body"
                      rows="6"
                      maxlength="255"
                    ></textarea>
                    <span class="word-count">0/255 characters</span>
                  </div>
                </div>
              </div>
              <div class="col" *ngIf="farmers.length > 0">
                <div class="text-primary">
                  <p>Recipients</p>
                </div>
                <ul>
                  <li class="text-secondary" *ngFor="let row of farmers">
                    {{ row }}
                  </li>
                </ul>
                <div class="text-primary" *ngIf="farmers.length < total">
                  <p>+&nbsp;{{ total - farmers.length }} other users</p>
                </div>
                <div  *ngIf="notification['sent'] && notification['clicks']" class="text-primary">
                  <p>{{ notification['clicks']}}&nbsp;user(s) clicked this notification</p>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="text-center" *ngIf="loading">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div class="w100" *ngIf="!loading">
              <div class="float-left">
                <button
                  type="button"
                  (click)="resetForm()"
                  class="float-left btn btn-outline-danger mr-2"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  *ngIf="!notification['sent']"
                  type="button"
                  (click)="saveNotification($event, false)"
                  class="btn btn-primary float-right"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- </form> -->

  <!-- 
        ==============================
        CTA modal 
        ================================
    -->

  <div
    class="modal fade"
    id="cta"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    #cta
    [ngClass]="{ show: showCtaModal === true }"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow-xl">
        <div class="modal-header">
          <h4 class="modal-title">Call to Action</h4>
          <!-- <button class="btn-close">Close</button> -->
        </div>
        <form [formGroup]="notificationForm.controls.clickAction">
          <div class="form">
            <div class="form-group p-4">
              <label class="control-label">Select Module</label>
              <p-dropdown
                [options]="modules"
                formControlName="page"
                placeholder="Select a module"
                filter="true"
                (onChange)="onModuleChange()"
                [style]="{ width: '100%', height: '35px' }"
              >
              </p-dropdown>
            </div>
            <div class="p-4 pb-1"
            *ngIf="
            notificationForm.get('clickAction').get('page').value ===
            'farm_manager_crop'
          ">
            <div   class="form-group">
              <label class="control-label">Select Crop</label>
              <p-dropdown
                defaultLabel="Select Crop"
                [options]="crops"
                placeholder="Select a crop"
                formControlName="crop"
               
              ></p-dropdown>
              <!-- optionValue="name"
              optionLabel="name" -->
            </div>
            <div class="form-group">
              <label class="control-label">Select Destination</label>
              <p-dropdown
                defaultLabel="Select Destination"
                placeholder="Select destination"
                [options]="farm_plan_destinations"
                formControlName="destination"
              ></p-dropdown>
            </div>
            </div>

            <!-- agrishop-->
            <div class="p-4 pb-1">
              <div class="form-group">
                <div
                  *ngIf="
                    notificationForm.get('clickAction').get('page').value ===
                    'shop_input_details'
                  "
                >
                  <label class="control-label">Select Product</label>
                  <p-autoComplete
                    [suggestions]="products"
                    [(ngModel)]="currentProduct"
                    class="card-text"
                    [delay]="1000"
                    [ngModelOptions]="{ standalone: true }"
                    completeOnFocus="true"
                    placeholder="Search Product"
                    field="name"
                    (completeMethod)="
                      getProducts({ salt: true, search__like: $event.query })
                    "
                    itemSize="30"
                    (onSelect)="handleProductSelect($event)"
                    optionalLabel="product"
                    [size]="30"
                  >
                    <ng-template let-item pTemplate="item">
                      <div class="ui-helper-clearfix">
                        <div style="font-size: 18px">{{ item.name }}</div>
                        <div>{{ item.supplier }}</div>
                        <div
                          *ngIf="!hasStock(item)"
                          style="color: rgb(204, 31, 31)"
                        >
                          Out of Stock
                        </div>
                      </div>
                    </ng-template>
                  </p-autoComplete>
                </div>
                <div
                  *ngIf="
                    notificationForm.get('clickAction').get('page').value ===
                    'promotions'
                  "
                >
                  <label class="control-label">Select Promotion</label>
                  <select class="form-co ntrol" formControlName="item">
                    <option
                      *ngFor="let row of openPromotions$ | async"
                      [ngValue]="row.id"
                    >
                      {{ row.promotion_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="right">
              <button class="btn btn-outline-primary" (click)="closeCTAModal()">
                Done
              </button>
              <!-- <button class="btn btn-primary" type="submit">Save</button> -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- 
        ================================
        Recepients modal 
        ================================
    -->

  <div
    class="modal fade"
    id="recepients"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    #cta
    [ngClass]="{ show: showRecepientsModal === true }"
  >
    <form
      [formGroup]="notificationForm.controls.userCriteria"
      (submit)="getRecipientsCount()"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Select Recipients</h4>
            <button class="close"></button>
          </div>

          <div class="form p-4">
            <div class="form-group">
              <label class="control-label">Select User Type</label>
              <label class="d-block py-1"
                ><input
                  type="radio"
                  [disabled]="notification['sent']"
                  formControlName="user_mode"
                  value=""
                />
                All</label
              >
              <label class="d-block py-1"
                ><input
                  type="radio"
                  [disabled]="notification['sent']"
                  formControlName="user_mode"
                  value="SMF"
                />
                Farmer</label
              >
              <label class="d-block py-1"
                ><input
                  type="radio"
                  [disabled]="notification['sent']"
                  formControlName="user_mode"
                  value="MA"
                />
                Merchant</label
              >
            </div>

            <label class="control-label">Select Limit</label>
            <select
              [(ngModel)]="multiple"
              [ngModelOptions]="{ standalone: true }"
              class="form-control"
            >
              <option value="">Select</option>
              <option value="single">Single</option>
              <option value="multiple">Multiple</option>
            </select>

            <form *ngIf="multiple === 'single'" (submit)="getFarmer($event)">
              <label class="control-label">Search User</label>
              <input
                [disabled]="notification['sent']"
                [(ngModel)]="userPhone"
                [ngModelOptions]="{ standalone: true }"
                class="form-control"
                placeholder="+2567xxxxxxxxx"
              />
              <label *ngIf="farmerName" class="text-info">{{
                farmerName
              }}</label>
            </form>

            <div *ngIf="districts | async" class="form-group">
              <label class="control-label">Select District</label>
              <p-multiSelect
                [options]="districts | async"
                defaultLabel="Select Districts"
                formControlName="districts"
              ></p-multiSelect>
              <div
                *ngIf="
                  notificationForm.get('userCriteria').get('districts').value
                "
              >
                Districts:
                <p>
                  {{
                    notificationForm.get("userCriteria").get("districts").value
                  }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">Select Crop</label>
              <p-multiSelect
                defaultLabel="Select Crops"
                [options]="crops"
                formControlName="crops"
               
              ></p-multiSelect>
            </div>
            <div>
              {{
                notificationForm.get("userCriteria").get("crops").value
              }}
              </div>
            <!-- optionValue="name"
            optionLabel="name" -->
          </div>
          <div class="modal-footer">
            <div class="row" *ngIf="!loading">
              <div class="col">
                <button
                  class="btn btn-outline-primary float-left"
                  type="button"
                  (click)="closeRecepientsModal()"
                >
                  Cancel
                </button>
              </div>
              <div class="col">
                <button type="submit" class="btn btn-primary float-right">
                  Confirm
                </button>
              </div>
            </div>

            <div class="text-center" *ngIf="loading">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- </form> -->

  <!-- 
        ==============================
        Publish modal 
        ==============================
    -->

  <div
    class="modal fade"
    id="cta"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    #publi
    [ngClass]="{ show: showCtaModal === true }"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content shadow-xl">
        <div class="modal-header">
          <h4 class="modal-title">Publish</h4>
          <button class="btn-close"></button>
        </div>
        <div class="modal-body">
          <label for="" class="control-label"></label>
          <input type="datetime" class="form-control" />
        </div>
      </div>
    </div>
  </div>
</div>
